import { storeToRefs } from 'pinia'
import { useFantasySeasonStore } from '@/stores/fantasy/season'
import { useFantasySeasonLeaderboard } from './use-fantasy-season-leaderboard'

export const useFantasySeasonEnded = () => {
  const { t } = useI18n()
  const { $dialog, $snacks } = useNuxtApp()
  const fantasySeasonStore = useFantasySeasonStore()
  const { handleOpenSeasonLeaderboard } = useFantasySeasonLeaderboard()

  const { data: season } = storeToRefs(fantasySeasonStore)

  const memberStatus = computed(() => season.value?.memberStatus)
  const topPosition = computed(() => memberStatus.value?.top_position ?? null)
  // Если top_position равен 0, то игрок не попал ни в один порог наград => его позицию в топе не показываем
  const hasTopPosition = computed(() => (topPosition.value ?? 0) > 0)
  const canClaim = computed(() => Boolean(season.value?.can_claim))
  const participantsCount = computed(
    () => season.value?.participants_count ?? 0
  )
  const rewardsClaimedCount = computed(
    () => season.value?.rewards_claimed_count ?? 0
  )
  const isPending = ref(false)

  const handleClaim = async () => {
    if (isPending.value || !canClaim.value) return

    const reward = season.value?.rewards?.find(item => item.is_available)

    try {
      isPending.value = true
      await fantasySeasonStore.claimSeasonReward()
      $snacks.success(t('claimSuccess'))

      if (reward) {
        $dialog({
          wrapper: null,
          content: defineAsyncComponent(
            () => import('~/components/fantasy/popups/claimed/index.vue')
          ),
          contentProps: { reward }
        })
      }
    } catch {
      $snacks.error(t('claimError'))
    } finally {
      isPending.value = false
    }
  }

  return {
    topPosition,
    canClaim,
    hasTopPosition,
    participantsCount,
    rewardsClaimedCount,
    isPending,
    handleOpenSeasonLeaderboard,
    handleClaim
  }
}
